export default "__VITE_ASSET__CoPZr8yY__"